import { Container, ContainerModule } from '@wix/typesafe-inversify';
import { Services } from './services';
import { AddWidgetService } from '../services/AddWidgetService/AddWidgetService';
import { AppDescriptorService } from '../services/AppDescriptorService/AppDescriptorService';
import { BobWidgetManifestFetcher } from '../services/BobWidgetServices/BobWidgetManifestFetcher';
import { BobWidgetImages } from '../services/BobWidgetServices/BobWidgetImages';
import { ConsoleLogger } from '../services/ConsoleLogger/ConsoleLogger';
import { Experiments } from '../services/Experiments/Experiments';
import { PagesService } from '../services/PagesService/PagesService';
import { PanelHandlers } from '../services/PanelHandlers/PanelHandlers';
import { ReadyAppData } from '../services/ReadyAppData/ReadyAppData';
import { Translations } from '../services/Translations/Translations';
import { MasterStructureFetcher } from '../services/MasterStructureFetcher/MasterStructureFetcher';
import { ManifestBuilder } from '../services/ManifestBuilder/ManifestBuilder';
import { EditorTransactions } from '../services/EditorTransactions/EditorTransactions';
import { Monitoring } from '../services/Monitoring/Monitoring';
import { Transaction } from '../services/Monitoring/Transaction';

import { EditorApp } from '../services/EditorApp/EditorApp';
import { PanelsApiFactory } from '@wix/blocks-widget-services/panels';
import { AppDescriptorApiFactory } from '@wix/blocks-widget-services/editor';
import { CommonSessionDataProvider } from '../services/Monitoring/CommonSessionDataProvider/CommonSessionDataProvider';
import { PromiseVoider } from '../services/PromiseVoider/PromiseVoider';

const thirdPartyModules = new ContainerModule((bind) => {
  bind(Services.PanelsApiFactory).toConstantValue(new PanelsApiFactory());
  bind(Services.AppDescriptorApi).toDynamicValue((context) =>
    new AppDescriptorApiFactory().createAppDescriptorApi({
      essentials: context.container.get(Services.PlatformEssentials),
    }),
  );
});

const singletonModules = new ContainerModule((bind) => {
  bind(Services.ReadyAppData).to(ReadyAppData).inSingletonScope();
  bind(Services.EditorApp).to(EditorApp).inSingletonScope();
  bind(Services.AppDescriptorService)
    .to(AppDescriptorService)
    .inSingletonScope();
});

const regularModules = new ContainerModule((bind) => {
  bind(Services.AddWidgetService).to(AddWidgetService);
  bind(Services.BobWidgetManifestFetcher).to(BobWidgetManifestFetcher);
  bind(Services.BobWidgetImages).to(BobWidgetImages);
  bind(Services.ConsoleLogger).to(ConsoleLogger);
  bind(Services.Experiments).to(Experiments);
  bind(Services.PagesService).to(PagesService);
  bind(Services.PanelHandlers).to(PanelHandlers);
  bind(Services.Translations).to(Translations);
  bind(Services.MasterStructureFetcher).to(MasterStructureFetcher);
  bind(Services.ManifestBuilder).to(ManifestBuilder);
  bind(Services.EditorTransactions).to(EditorTransactions);
  bind(Services.Monitoring).to(Monitoring);
  bind(Services.CommonSessionDataProvider).to(CommonSessionDataProvider);
  bind(Services.Transaction).to(Transaction);
  bind(Services.PromiseVoider).to(PromiseVoider);
  bind(Services.TransactionFactory).toDynamicValue((context) => {
    return (name: string) => {
      return context.container.get(Services.Transaction).init(name);
    };
  });
});

export const container = new Container();

container.load(thirdPartyModules, singletonModules, regularModules);
